<template>
	<div class="p-grid crud-demo">
		<div class="p-col-12">
			<div class="card">
				<Toolbar class="p-mb-4">
					<template v-slot:left>
						<Button label="添加" icon="pi pi-plus" class="p-button-success p-mr-2" @click="onAddClick" />
					</template>
				</Toolbar>

				<DataTable :value="notices" dataKey="_id" :paginator="true" :rows="25" :rowHover="true" showGridlines 
							paginatorTemplate="FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport RowsPerPageDropdown" :rowsPerPageOptions="[5,10,25,50]"
							currentPageReportTemplate="Showing {first} to {last} of {totalRecords} notices" responsiveLayout="stack">
					<template #header>
						<div style="text-align: center">
							<h4 class="p-m-0">通知公告</h4>
						</div>
					</template>

					<Column field="title" header="标题" headerStyle="width: 30%">
						<template #body="slotProps">
							{{slotProps.data.title}}
						</template>
					</Column>
					<Column field="content" header="内容" headerStyle="width: 60%">
						<template #body="slotProps">
							{{slotProps.data.content}}
						</template>
					</Column>
					<Column header="操作" headerStyle="width: 10%">
						<template #body="slotProps">
							<Button icon="pi pi-pencil" v-tooltip.top="'编辑'" class="p-button-rounded p-button-success p-mr-2" @click="onEditClick(slotProps.data)" />
							<Button icon="pi pi-paperclip" v-tooltip.top="'附件'" class="p-button-rounded p-button-primary p-mr-2" @click="onAttachmentClick(slotProps.data)" />
							<Button icon="pi pi-trash" v-tooltip.top="'删除'" class="p-button-rounded p-button-warning" @click="onDeleteClick(slotProps.data)" />
						</template>
					</Column>
				</DataTable>

				<Dialog v-model:visible="noticeDialog" :header="crudOperation==='create'?'新建通知':crudOperation==='update'?'编辑通知':''" :modal="true" class="p-fluid">
					<div class="p-field">
						<label for="title">标题</label>
						<InputText id="title" v-model.trim="notice.title" required="true" autofocus />
					</div>
					<div class="p-field">
						<label for="content">内容</label>
						<!-- <InputText id="content" v-model.trim="notice.content" required="true" autofocus :class="{'p-invalid': submitted && !notice.content}" /> -->
						<Textarea v-model="notice.content" :autoResize="true" rows="10" cols="50" required="true" autofocus />
					</div>

					<template #footer>
						<div v-if="crudOperation==='create'">
							<Button label="取消" icon="pi pi-times" style="margin-right: 1em" class="p-button-text" @click="hideDialog" />
							<Button label="创建" icon="pi pi-check" class="p-button-raised p-button-primary" @click="createNotice" />
						</div>
						<div v-if="crudOperation==='update'">
							<Button label="取消" icon="pi pi-times" style="margin-right: 1em" class="p-button-text" @click="hideDialog" />
							<Button label="编辑" icon="pi pi-check" class="p-button-raised p-button-primary" @click="editNotice" />
						</div>
					</template>
				</Dialog>

				<Dialog v-model:visible="attachmentDialog" header="编辑附件" :modal="true" class="p-fluid">
					<div class="p-field">
						<label for="title">标题</label>
						<InputText id="title" v-model.trim="notice.title" required="true" autofocus disabled />
					</div>
					<div class="p-field">
						<label for="content">内容</label>
						<!-- <InputText id="content" v-model.trim="notice.content" required="true" autofocus :class="{'p-invalid': submitted && !notice.content}" /> -->
						<Textarea v-model="notice.content" :autoResize="true" rows="3" cols="50" required="true" autofocus disabled />
					</div>
					<div class="p-field" v-if="notice.attachments && notice.attachments.length">
						<label style="color: RGB(33, 150, 243)">已有附件</label>
						<div v-for="(attachment, index) of notice.attachments" :key="index" style="margin-bottom: 10px">
							<div v-if="attachment">
								<a :href="attachmentUrl(notice._id, attachment._id)" target="_blank">
									<span v-tooltip.top="'点击预览'">{{ attachment.name }}</span>
								</a>
								<i class="pi pi-times" style="color: red; cursor: pointer; margin-left: 10px;" v-tooltip.top="'删除附件'" @click="deleteAttachment(notice._id, attachment._id)"></i>
							</div>
						</div>
					</div>
					<div class="p-field">
						<label style="color: RGB(104, 159, 56)">新增附件</label>
						<div>
							<input type="file" id="file" ref="file" v-on:change="handleFileUpload()"/>
							<button type="button" class="button" @click="addAttachment">上传</button>
							<!-- <Button label="Success" class="p-button-success" /> -->
						</div>
					</div>

					<template #footer>
						<!-- <Button label="取消" icon="pi pi-times" style="margin-right: 1em" class="p-button-text" @click="attachmentDialog=false" />
						<Button label="确定" icon="pi pi-check" class="p-button-raised p-button-primary" @click="addAttachment" /> -->
						<Button label="关闭" icon="pi pi-times" style="margin-right: 1em" class="p-button-text" @click="attachmentDialog=false" />
					</template>
				</Dialog>

				<Dialog v-model:visible="deleteNoticeDialog" :style="{width: '450px'}" header="消息确认" :modal="true">
					<div>
						<i class="pi pi-exclamation-triangle p-mr-3" style="font-size: 2em; color: orange; vertical-align: middle;" />
						<span style="color: orange">确定要删除如下通知吗?</span>
						<div style="text-indent: 3em;">标题：{{ notice.title }}</div>
					</div>
					<template #footer>
						<Button label="取消" icon="pi pi-times" class="p-button-text" @click="deleteNoticeDialog = false"/>
						<Button label="确定" icon="pi pi-check" class="p-button-primary" @click="deleteNotice" />
					</template>
				</Dialog>
			</div>
		</div>
	</div>

</template>

<script>
import NoticeService from '../service/NoticeService';

export default {
	data() {
		return {
			notices: null,
			crudOperation: '',    // 'create', 'read', 'update' or 'delete'
			noticeDialog: false,
			deleteNoticeDialog: false,
			attachmentDialog: false,
			notice: {},
			attachment: null,
		}
	},
	noticeService: null,
	created() {
		this.noticeService = new NoticeService();
	},
	mounted() {
		// Permission guard
		if(!this.isAdmin) {
			this.$router.push({path: '/access'});
			return;
		}	

		this.loadData();
	},
	methods: {
		loadData() {
			this.noticeService.findNotices().then(data => this.notices = data);
		},
		onAddClick() {
			this.crudOperation = "create";
			this.notice = {};
			this.noticeDialog = true;
		},
		onEditClick(notice) {
			this.crudOperation = "update";
			this.notice = {};
			this.notice._id = notice._id;
			this.notice.title = notice.title;
			this.notice.content = notice.content;
			this.noticeDialog = true;
		},
		onAttachmentClick(n) {
			this.noticeService.findNotice(n._id).then((notice) => {
				this.notice = notice;
				this.attachmentDialog = true;
			});
		},
		onDeleteClick(notice) {
			this.notice = notice;
			this.deleteNoticeDialog = true;
		},
		hideDialog() {
			this.noticeDialog = false;
		},
		createNotice() {
			this.noticeService.addNotice(this.notice).then((notice) => {
				this.noticeDialog = false;
				this.noticeService.findNotices()
                    .then(notices => { 
						this.notices = notices;
						// loader.hide();
						this.$toast.add({severity: 'info', summary: '通知创建成功', detail: `标题: ${notice.title}`, life: 5000});
					}).catch(error => {
						// loader.hide();
						if(error.response) {
							this.$toast.add({ severity: 'error', summary: '通知信息加载失败', detail: error.response.data.message });
						} else {
							this.$toast.add({ severity: 'error', summary: '通知信息加载失败', detail: error.message });
						}
					})
				
			}).catch(error => {
				// loader.hide();
				if(error.response) {
					this.$toast.add({ severity: 'error', summary: '操作失败', detail: error.response.data.message });
				} else {
                    this.$toast.add({ severity: 'error', summary: '操作失败', detail: error.message });
				}
			})
		},
		editNotice() {
			this.noticeService.updateNotice(this.notice._id, this.notice).then((notice) => {
				this.noticeDialog = false;
				this.noticeService.findNotices()
                    .then(notices => { 
						this.notices = notices;
						// loader.hide();
						this.$toast.add({severity: 'info', summary: '通知修改成功', detail: `标题: ${notice.title}`, life: 5000});
					}).catch(error => {
						// loader.hide();
						if(error.response) {
							this.$toast.add({ severity: 'error', summary: '通知信息加载失败', detail: error.response.data.message });
						} else {
							this.$toast.add({ severity: 'error', summary: '通知信息加载失败', detail: error.message });
						}
					})
				
			}).catch(error => {
				// loader.hide();
				if(error.response) {
					this.$toast.add({ severity: 'error', summary: '操作失败', detail: error.response.data.message });
				} else {
                    this.$toast.add({ severity: 'error', summary: '操作失败', detail: error.message });
				}
			})
		},
		deleteNotice() {
			// let loader = this.$loading.show();
			this.noticeService.deleteNotice(this.notice._id)
			.then((notice) => {
				this.deleteNoticeDialog = false;
				this.noticeService.findNotices()
                    .then(notices => { 
						this.notices = notices; 
						// loader.hide();
						this.$toast.add({severity: 'info', summary: '通知删除成功', detail: `标题: ${notice.title}`, life: 5000});
                    }).catch(error => {
						// loader.hide();
						if(error.response) {
							this.$toast.add({ severity: 'error', summary: '用户信息加载失败', detail: error.response.data.message });
						} else {
							this.$toast.add({ severity: 'error', summary: '用户信息加载失败', detail: error.message });
						}
					})
				
			}).catch(error => {
				// loader.hide();
				if(error.response) {
					this.$toast.add({ severity: 'error', summary: '操作失败', detail: error.response.data.message });
				} else {
                    this.$toast.add({ severity: 'error', summary: '操作失败', detail: error.message });
				}
			});
		},
		handleFileUpload(){
            this.attachment = this.$refs.file.files[0];
            // console.log(this.attachment);
        },
		// addAttachment() {
        //     let formData = new FormData();
        //     formData.append('attachment', this.attachment);

        //     let loader = this.$loading.show();
        //     this.noticeService.addAttachment(formData, this.notice._id)
        //     .then(() => {
        //         this.loadData();
        //         loader.hide();
        //         this.$toast.add({severity: 'info', summary: '附件添加成功', detail: '', life: 5000});
        //         this.attachmentDialog = false;
        //     }).catch(error => {
        //         loader.hide();
        //         if(error.response) {
        //             this.$toast.add({ severity: 'error', summary: '操作失败', detail: error.response.data.message });
        //         } else {
        //             this.$toast.add({ severity: 'error', summary: '操作失败', detail: error.message });
        //         }
        //     });
        // },
		addAttachment() {
			if(!this.attachment) {
				this.$toast.add({severity: 'warn', summary: '请先选择文件', detail: '', life: 5000});
				return;
			}

            let formData = new FormData();
            formData.append('attachment', this.attachment);

            let loader = this.$loading.show();
            this.noticeService.addAttachment(formData, this.notice._id)
            .then(() => {
				this.noticeService.findNotice(this.notice._id).then((notice) => {
					this.notice = notice;
				});

				this.attachment = null;
				this.$refs.file.value=null;

                loader.hide();
                this.$toast.add({severity: 'info', summary: '附件添加成功', detail: '', life: 5000});
            }).catch(error => {
                loader.hide();
                if(error.response) {
                    this.$toast.add({ severity: 'error', summary: '操作失败', detail: error.response.data.message });
                } else {
                    this.$toast.add({ severity: 'error', summary: '操作失败', detail: error.message });
                }
            });
        },
		deleteAttachment(noticeId, attachmentId) {
            let loader = this.$loading.show();
            this.noticeService.deleteAttachment(noticeId, attachmentId)
            .then(() => {
                this.noticeService.findNotice(noticeId).then((notice) => {
					this.notice = notice;
					this.attachmentDialog = true;
				});
                loader.hide();
                this.$toast.add({severity: 'info', summary: '附件删除成功', detail: '', life: 5000});
            }).catch(error => {
                loader.hide();
                if(error.response) {
                    this.$toast.add({ severity: 'error', summary: '操作失败', detail: error.response.data.message });
                } else {
                    this.$toast.add({ severity: 'error', summary: '操作失败', detail: error.message });
                }
            });
        },
		attachmentUrl(noticeId, attachmentId) {
            return this.noticeService.attachmentUrl(noticeId, attachmentId);
		},
	
	},
	computed: {
		loggedIn() {
            return this.$store.state.authentication.status.loggedIn;
        },
        userInfo() {
            return this.$store.state.authentication.user;
		},
		canApprove() {
            return this.isPreapprover || this.isApprover;
        },
        isPreapprover() {
			return this.$store.state.authentication.permissions.preapprover === true;
        },
        isApprover() {
			return this.$store.state.authentication.permissions.approver === true;
		},
		isAdmin() {
			return this.$store.state.authentication.permissions.admin === true;
		},
    }
}
</script>

<style scoped>
.button {
	/* display: inline-block; */
	background-color: RGB(104, 159, 56);
	/* border-radius: 10px; */
	border: 4px double #cccccc;
	color: #eeeeee;
	text-align: center;
	font-size: 1.2em;
	/* padding: 20px; */
	/* width: 200px; */
	/* -webkit-transition: all 0.5s;
	-moz-transition: all 0.5s;
	-o-transition: all 0.5s;
	transition: all 0.5s; */
	cursor: pointer;
	/* margin: 5px; */
}

.button:hover {
	background-color: green;
}

.button:active {
	background-color: orange;
	box-shadow: 0 5px gray;
	transform: translateY(2px);
}
</style>
